<div class="obg-m-terms-and-conditions-content" *ngIf="showUpdatedTermsAndConditions">
	<obg-m-overlay-spinner *ngIf="isBusy"></obg-m-overlay-spinner>
	<obg-m-updated-terms-and-conditions-container (busy)="changeBusyState($event)" hideReadMore>
	</obg-m-updated-terms-and-conditions-container>
</div>
<obg-content-section-group-container
	[document]="document"
	[hideBanner]="true"
	[keysToBeUsedWithinDocumentType]="currentVersion?.resourceKeys"
>
</obg-content-section-group-container>
